import { GetProfileResponseDto } from '@shared/core/users'

export function buildChurnSurveyHiddenFields(input: {
  profile: GetProfileResponseDto
  planName: string
  subscriptionStartDateIso: string
  activeEventsCount: number | 'unknown'
  selectedCalendarsCount: number | 'unknown'
}): Record<string, string> {
  return {
    user_id: String(input.profile.id),
    account_created_at: new Date(input.profile.created_at).toISOString() ?? 'unknown',
    subscription_plan_name: input.planName.trim() ? input.planName : 'unknown',
    subscription_plan_start_date: input.subscriptionStartDateIso,
    active_events_count: input.activeEventsCount === 'unknown' ? 'unknown' : String(input.activeEventsCount),
    selected_calendars_count:
      input.selectedCalendarsCount === 'unknown' ? 'unknown' : String(input.selectedCalendarsCount),
  }
}
